import { useState } from "react";
import { maskNumber } from "../../../utils/helper";
import { BackgroundWrapper } from "../../atoms/backgroundWrapper/BackgroundWrapper";
import { DynamicCard } from "../dynamicCard/DynamicCard";
import style from "./callDetails.module.scss";

interface CallDetailsProps {
  data: any;
}

export const CallDetails: React.FC<CallDetailsProps> = ({ data }) => {
  const [audioError, setAudioError] = useState<string | null>(null);
  const filterObjectByKeys = (obj: any, keys: any) => {
    return keys.reduce((acc: any, key: any) => {
      if (key in obj) {
        acc[key] = obj[key]||"N/A";
      }
      return acc;
    }, {});
  };

  const keysToExtract = ["callerId","callResponse", "duration", "startTime", "endTime"];
  const keysToExtract2 = [
    "timeToAnswer",
    "status",
    "hangupBy",
    "agentId",
    "dialStatus",
    "callType"
  ];

  const filteredData1 = (() => {
    const raw = filterObjectByKeys(data, keysToExtract);
    if (raw.callerId) raw.callerId = maskNumber(raw.callerId);
    return raw;
  })();
  const filteredData2 = filterObjectByKeys(data, keysToExtract2);

  return (
    <>
      <BackgroundWrapper>
        <p className={style.heading}>Call Details</p>
        <div className={style.card_align}>
          <DynamicCard
            className={style.fontStyles}
            key={data._id}
            data={filteredData1}
            excludeFields={[]}
          />
          <DynamicCard
            className={style.fontStyles}
            key={data._id}
            data={filteredData2}
            excludeFields={[]}
          />
        </div>
        {data?.audioFile && (
          <div className={style.audio_wrapper}>
            <p className={style.audio_label}>Call Recording:</p>
            {audioError ? (
              <p className={style.audio_error}>{audioError}</p>
            ) : (
              <audio 
                controls 
                controlsList="nodownload"
                onContextMenu={(e) => e.preventDefault()}
                className={style.audio_player}
                onError={(e: any) => {
                  const error = e.target.error;
                  const errorMsg = error?.code === 4 
                    ? "Recording format not supported" 
                    : "Recording not available";
                  setAudioError(errorMsg);
                }}
              >
                <source src={data.audioFile} type="audio/mpeg" />
                Your browser does not support the audio element.
              </audio>
            )}
          </div>
        )}
      </BackgroundWrapper>
    </>
  );
};
